/*
 *
 * Ctydents reducer
 *
 */
import produce from "immer";
import {
  FLUSH_STATE,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR
} from "./constants";

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  itemsList: [],
  appointments: [],
  options: false,
};

/* eslint-disable default-case, no-param-reassign */
const agendaReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_COURSES:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = [];
        draft.appointments = [];
        draft.options = action.options;
        break;

      case LOAD_COURSES_SUCCESS:
        draft.loading = false;
        draft.itemsList = action.itemsList;
        draft.appointments = action.appointments;
        break;

      case LOAD_COURSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.itemsList = [];
        draft.appointments = [];
        draft.options = false;
        break;

    }
  });

export default agendaReducer;
